import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import LandingPage from "@/pages/store/landing/page";
import LoginPage from "@/pages/auth/login";
import ForgotPasswordPage from "@/pages/auth/forgot-password";
import ResetPasswordPage from "@/pages/auth/reset-password";
import AuthCallbackPage from "@/pages/auth/callback";
import AuthGuard from "@/components/feature/AuthGuard";
import DashboardPage from "@/pages/admin/dashboard/page";
import OrdersPage from "@/pages/admin/orders/page";
import ProduccionPage from "@/pages/admin/produccion/page";
import ProductsPage from "@/pages/admin/products/page";
import InventoryPage from "@/pages/admin/inventory/page";
import InventoryMovementsPage from "@/pages/admin/movements/page";
import SalesPage from "@/pages/admin/sales/page";
import CustomersPage from "@/pages/admin/customers/page";
import ReturnsPage from "@/pages/admin/returns/page";
import ExchangesPage from "@/pages/admin/exchanges/page";
import WarrantiesPage from "@/pages/admin/warranties/page";
import SizesPage from "@/pages/admin/sizes/page";
import DistributorsPage from "@/pages/admin/distributors/page";
import SalespersonsPage from "@/pages/admin/salespersons/page";
import CommissionsPage from "@/pages/admin/commissions/page";
import PaymentsPage from "@/pages/admin/payments/page";
import ExpensesPage from "@/pages/admin/expenses/page";
import DonationsPage from "@/pages/admin/donations/page";
import CampaignsPage from "@/pages/admin/campaigns/page";
import MetaFunnelPage from "@/pages/admin/embudo/page";
import ReportsPage from "@/pages/admin/reports/page";
import DocumentsPage from "@/pages/admin/documents/page";
import SuppliersPage from "@/pages/admin/suppliers/page";
import PurchasesPage from "@/pages/admin/purchases/page";
import ConsignmentsPage from "@/pages/admin/consignments/page";
import UsersPage from "@/pages/admin/usuarios/page";
import AuditPage from "@/pages/admin/auditoria/page";
import ResetDataPage from "@/pages/admin/reinicio/page";
import ConfigPage from "@/pages/admin/configuracion/page";
import AdminFaqPage from "@/pages/admin/faq/page";
import AdminTestimoniosPage from "@/pages/admin/testimonios/page";
import DiscountsPage from "@/pages/admin/descuentos/page";
import ProductDetailPage from "@/pages/store/product/page";
import CheckoutPage from "@/pages/store/checkout/page";
import PaymentConfirmPage from "@/pages/store/checkout/confirmacion/page";
import EpaycoPayPage from "@/pages/store/checkout/epayco/page";
import OrderTrackingPage from "@/pages/store/orders/page";

const routes: RouteObject[] = [
  { path: "/", element: <LandingPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/auth/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/auth/reset-password", element: <ResetPasswordPage /> },
  { path: "/auth/callback", element: <AuthCallbackPage /> },

  // Panel administrativo protegido por AuthGuard (requiere sesión activa).
  {
    path: "/admin",
    element: <AuthGuard />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "pedidos", element: <OrdersPage /> },
      { path: "produccion", element: <ProduccionPage /> },
      { path: "productos", element: <ProductsPage /> },
      { path: "inventario", element: <InventoryPage /> },
      { path: "ventas", element: <SalesPage /> },
      { path: "clientes", element: <CustomersPage /> },
      { path: "devoluciones", element: <ReturnsPage /> },
      { path: "cambios", element: <ExchangesPage /> },
      { path: "garantias", element: <WarrantiesPage /> },

      // FASE 2C — 17 rutas administrativas "Próximamente"
      { path: "tallas", element: <SizesPage /> },
      { path: "movimientos", element: <InventoryMovementsPage /> },
      { path: "compras", element: <PurchasesPage /> },
      { path: "proveedores", element: <SuppliersPage /> },
      { path: "distribuidores", element: <DistributorsPage /> },
      { path: "consignaciones", element: <ConsignmentsPage /> },
      { path: "vendedores", element: <SalespersonsPage /> },
      { path: "comisiones", element: <CommissionsPage /> },
      { path: "pagos", element: <PaymentsPage /> },
      { path: "gastos", element: <ExpensesPage /> },
      { path: "donaciones", element: <DonationsPage /> },
      { path: "marketing", element: <CampaignsPage /> },
      { path: "embudo", element: <MetaFunnelPage /> },
      { path: "reportes", element: <ReportsPage /> },
      { path: "documentos", element: <DocumentsPage /> },
      { path: "usuarios", element: <UsersPage /> },
      { path: "auditoria", element: <AuditPage /> },
      { path: "reinicio", element: <ResetDataPage /> },
      { path: "configuracion", element: <ConfigPage /> },
      { path: "faq", element: <AdminFaqPage /> },
      { path: "testimonios", element: <AdminTestimoniosPage /> },
      { path: "descuentos", element: <DiscountsPage /> },
    ],
  },

  // Tienda pública conectada a Supabase
  // El catálogo ahora vive dentro del inicio (ancla #catalogo). Los enlaces
  // antiguos a /catalogo se redirigen a la sección del inicio.
  { path: "/catalogo", element: <Navigate to="/" state={{ scrollTo: 'catalogo' }} replace /> },
  { path: "/producto/:slug", element: <ProductDetailPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/checkout/epayco", element: <EpaycoPayPage /> },
  { path: "/checkout/confirmacion", element: <PaymentConfirmPage /> },
  { path: "/pedidos", element: <OrderTrackingPage /> },

  { path: "*", element: <NotFound /> },
];

export default routes;